module.exports = __webpack_public_path__ + "static/media/matilde-cap-brazil-sad.4c27eda6.png";